module.exports = __webpack_public_path__ + "static/media/home-nosotros.6c1b2605.jpg";